




































































import moment from 'moment';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import config from '@/config/index';
import { Component, Prop } from 'vue-property-decorator';
import { IFuncionalidad } from '@/interfaces/Funcionalidad';
import { actionsEvent } from '@/setup';
import { Accion } from '@/config/enums';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { Funcionalidades } from '@/config/funcionalidades';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import Confirmation from '@/components/Confirmation.vue';
import HandleErrors from '@/config/handleErrors';
import store from '@/store';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import {
  checkboxColumnDef,
  makeAccionesColumnDef,
} from '@/reusable/Grid/aggridColumnDefUtils';

import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import { LoadingService } from '@/services/loadingService';
import { fetchVerificacion } from '../fetchVerificacion';
import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import TablaTotalSims from './TablaTotalSims.vue';
import { utils, writeFileXLSX } from 'xlsx';

@Component({
  components: {
    MantenedorGrid,
    MantenedorGridSinCodigo,
    TablaTotalSims,
  },
})
export default class TabalSimsSelected extends ComponenteBase {
  @Prop({ required: true }) solicitud: number;
  filtro: string = '';
  ordesList: any[] = [];
  funcionalidad: Funcionalidades =
    Funcionalidades.TablaSimsVerificacionBajaCliente;
  usuario = JSON.parse(localStorage.getItem('user')).id;
  totalDispositivos: boolean = false;

  mounted() {
    this.initialize();
  }

  returnUnicos(data: any) {
    let hash: any = {};
    let unicos = data.filter((seleccion: any) =>
      hash[seleccion.serienumero] ? false : (hash[seleccion.serienumero] = true)
    );
    return unicos;
  }

  calcularSims() {
    let dispositivosSims = this.ordesList.filter(
      (e: any) => e.simserienumero != ''
    );
    this.$emit('dispositivosSim', dispositivosSims.length);
  }

  agregarCliente(data: any) {
    this.ordesList.push(data);
    let totalData = this.ordesList;
    this.ordesList = this.returnUnicos(totalData);
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');

    console.log(this.ordesList);
    this.calcularSims();
    this.enviarDatos();
  }

  async getEquipos() {
    this.loadingService.showLoading();
    return fetchVerificacion(
      {
        solicitud: this.solicitud,
      },
      'conecta_verificacion_baja_cliente/get_equipos_confirmados'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return data.data.data.LISTA;
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        this.$snotify.error('Ocurrió un error al cargar los equipos', {
          timeout: 3000,
        });
        return [];
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return [];
      });
  }
  ejecutada: boolean = false;
  async cargarEquipos() {
    this.ejecutada = true;
    this.ordesList = await this.getEquipos();
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  exportarExcel() {
    if (this.ordesList.length == 0) {
      this.$snotify.error('Por favor, agregue al menos un equipo', {
        timeout: 3000,
      });
      return;
    }
    let informacionOrdenada = this.ordesList.map((e: any) => {
      return {
        Serie: e.serienumero,
        Sim: e.simserienumero,
        Cliente: e.cliente_nombre,
      };
    });
    const ws = utils.json_to_sheet(informacionOrdenada);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Equipos_Seleccionados_Baja');
    writeFileXLSX(wb, 'Equipos_Seleccionados_Baja.xlsx');
    this.$snotify.success('Excel Exportado con éxito', 3000);
  }

  async handleGridReady(event: GridReadyEvent) {
    this.ordesList = [];
    this.gridApi = event.api;
    this.gridApi.setRowData(this.ordesList);
    this.gridApi.setDomLayout('autoHeight');
  }

  onModelUpdated() {
    if (!this.gridApi) {
      return;
    }
  }

  onSelectionChanged(params: any) {}

  pasoActivoIndex = 1;
  pasoActivoEditar = 1;

  //Declarar todas las Acciones Mantenedores
  accionConsultar: PermisoAccion = {
    accionCodigo: 1,
    visible: false,
  };
  accionCrear: PermisoAccion = {
    accionCodigo: 2,
    visible: true,
  };

  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: true,
  };

  accionesTotales: PermisoAccion[] = [
    this.accionConsultar,
    this.accionCrear,
    this.accionExportar,
  ];

  // Globales

  search: string = '';
  localeText: any = config.agGridTextos;
  gridOptions: GridOptions;
  loadingService = new LoadingService();
  intervalo: any; //Intervalo para el buscador
  handleErrors: HandleErrors = new HandleErrors();
  AccionesPerfilesAsociados: number = 0;

  // Controller
  readonly controller: string = 'funcionalidad';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);

  // Grilla
  gridApi: GridApi;
  columnApi: ColumnApi;
  columnDefs: Array<ColDef> = [];
  agGridUtil: AgGridUtil;
  serverSide: any;

  // Interfaces
  funcionalidades: Array<IFuncionalidad> = [];

  //vuex
  usuarioId: number = store.state.userId;

  showModalEdit: boolean = false;
  modalEsEdicion: boolean = false;

  dateFormatter(params: any) {
    return moment(params.value).format('YYYY-MM-DD');
  }

  enviarDatos() {
    this.$emit('informacion', this.ordesList.length);
  }

  constructor() {
    super();
    this.columnDefs = [
      {
        headerName: 'Serie',
        field: 'serienumero',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 400,
        width: 400,
        lockPinned: true,
      },
      {
        headerName: 'Sim',
        field: 'simserienumero',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 400,
        width: 400,
        lockPinned: true,
      },
      {
        headerName: 'Cliente',
        field: 'cliente_nombre',
        cellStyle: { textAlign: 'left' },
        resizable: false,
        sortable: false,
        minWidth: 400,
        width: 400,
        lockPinned: true,
      },
    ];

    this.gridOptions = {
      localeText: {
        noRowsToShow: 'No se han seleccionado sim cards',
      },
      pagination: true,
      paginationPageSize: 6, //Solución Paginación
      //cacheBlockSize: 50, //Solución Paginación
      //paginationAutoPageSize: false,
      rowModelType: 'normal',
      columnDefs: this.columnDefs,
      //rowModelType: 'serverSide',
      serverSideDatasource: this.serverSide,
      rowSelection: 'single',
      columnTypes: {
        fecha: {
          sortable: true,
          resizable: true,
          filter: false,
        },
      },
      suppressCsvExport: true,
      suppressExcelExport: true,
      onGridReady: this.handleGridReady,
      onModelUpdated: this.onModelUpdated,
      onSelectionChanged: this.onSelectionChanged,
      processCellForClipboard: ({ value }) => {
        return value instanceof moment
          ? this.formatFecha(value as moment.Moment)
          : value;
      },
      onGridSizeChanged: event => {
        //event.api.sizeColumnsToFit();
      },
    };
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('YYYY-MM-DD');
  }

  initialize() {
    actionsEvent.$on('actionsEvent', (data: any) => {
      if (
        this.funcionalidad === Funcionalidades.TablaSimsVerificacionBajaCliente
      ) {
        if (data.action === Accion.Eliminar) {
          let item: any = null;
          this.gridApi.forEachNode((rowNode: RowNode) => {
            if (data.id == rowNode.data.id) {
              item = rowNode.data;
              return true;
            }
          });
          if (item !== null) {
            let indexDelete = this.ordesList.indexOf(
              data.cellRendererParams.data
            );
            this.ordesList.splice(indexDelete, 1);
            this.gridApi.setRowData(this.ordesList);
            this.gridApi.setDomLayout('autoHeight');
            this.enviarDatos();
            this.calcularSims();
          }
        }
      }
    });
  }

  async editarDetalles(
    motivo: number,
    observacion: string,
    cantidadSims: number
  ): Promise<boolean> {
    let self = this;
    this.loadingService.showLoading();
    return fetchVerificacion(
      {
        solicitud: this.solicitud,
        usuario: JSON.parse(window.localStorage.user).id,
        equipos: this.ordesList,
        motivo: motivo,
        observacion: observacion,
        cantidadSims: cantidadSims,
      },
      'conecta_verificacion_baja_cliente/editar_solicitud_detalles'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          return true;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
        return false;
      })
      .catch((error: any) => {
        self.$snotify.error(
          'Hubo un error al crear el detalle de la solicitud',
          {
            timeout: 3000,
          }
        );
        return false;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return false;
      });
  }
}
